import { render } from "./formas-table.vue?vue&type=template&id=510d5c6b"
import script from "./formas-table.vue?vue&type=script&lang=js"
export * from "./formas-table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__